module.exports = __webpack_public_path__ + "static/media/frog(28).9fc8d2a9.PNG";